module.exports = __webpack_public_path__ + "static/media/laptop.2ef3b84b.png";